import * as t from "../actions";

const initialSchemaState: any = {
  dimensions: [],
  metrics: []
};

export default function (state = initialSchemaState, action: IPayload) {
  switch (action.type) {
    case t.ADD_SCHEMA:
      return { ...state, ...action.payload };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/ReportForm/reducer/schema.ts